export const num2name = {
    0: "PRIVATE",
    1: "PUBLIC",
};
export const name2num = {
    PRIVATE: 0,
    PUBLIC: 1,
};
